/* CW review-form polish v3 — external (stars handled by inline FL CSS, JS-based i18n) */
(function(){
function getLoc(){
  var l=document.documentElement.lang||'en';
  return l.slice(0,2).toLowerCase();
}
function applyI18n(){
  var loc=getLoc();
  var d=(window.CW_RV_LOCALES||{})[loc] || (window.CW_RV_LOCALES||{})['da'] || (window.CW_RV_LOCALES||{})['en'] || {};
  document.querySelectorAll('[data-i18n]').forEach(function(el){
    var k=el.getAttribute('data-i18n');
    if(d[k])el.textContent=d[k];
  });
  document.querySelectorAll('[data-i18n-ph]').forEach(function(el){
    var k=el.getAttribute('data-i18n-ph');
    if(d[k])el.setAttribute('placeholder',d[k]);
  });
  var form=document.getElementById('cwRvForm');
  if(form && d.js_alert)form.setAttribute('data-rate-required',d.js_alert);
}
function init(){
  applyI18n();
  var stars=document.querySelectorAll('#cwRvFormStars .cw-rv-f-star');
  if(!stars.length)return;
  var picked=0;
  function paint(n){stars.forEach(function(x,j){x.classList.toggle('on',j<n);x.classList.remove('preview');});}
  function preview(n){stars.forEach(function(x,j){x.classList.toggle('preview',j<n && !x.classList.contains('on'));});}
  stars.forEach(function(s,i){
    s.addEventListener('mouseover',function(){if(picked===0)preview(i+1);});
    s.addEventListener('mouseleave',function(){stars.forEach(function(x){x.classList.remove('preview');});});
    s.addEventListener('click',function(){picked=i+1;paint(picked);});
  });
  var recBtns=document.querySelectorAll('.cw-rv-f-recbtn');
  recBtns.forEach(function(b){b.addEventListener('click',function(){recBtns.forEach(function(x){x.classList.remove('on');});b.classList.add('on');});});
  var ta=document.getElementById('cwRvFBody');
  var ctr=document.getElementById('cwRvFBodyCount');
  if(ta&&ctr){function u(){var n=ta.value.length;ctr.textContent=n+'/500';ctr.classList.toggle('warn',n>=480);}ta.addEventListener('input',u);u();}
  var pIn=document.getElementById('cwRvFPhotos');
  var pPrev=document.getElementById('cwRvFPhotosPreview');
  var pFiles=[];
  if(pIn&&pPrev){
    pIn.addEventListener('change',function(){var nf=Array.from(pIn.files||[]);nf.forEach(function(f){if(pFiles.length<6)pFiles.push(f);});pIn.value='';render();});
    function render(){pPrev.innerHTML='';pFiles.forEach(function(f,idx){var url=URL.createObjectURL(f);var div=document.createElement('div');div.className='cw-rv-photo-thumb';var img=document.createElement('img');img.src=url;img.alt='';var btn=document.createElement('button');btn.type='button';btn.className='cw-rv-photo-x';btn.textContent='\u00d7';btn.addEventListener('click',function(){pFiles.splice(idx,1);render();});div.appendChild(img);div.appendChild(btn);pPrev.appendChild(div);});}
  }
  window.cwRvSubmit=function(e){
    e.preventDefault();
    if(picked===0){
      var f=document.getElementById('cwRvForm');
      var msg=(f&&f.getAttribute('data-rate-required'))||'Please select a rating.';
      alert(msg);
      return false;
    }
    var fw=document.getElementById('cwRvFormWrap');
    var tw=document.getElementById('cwRvThanksWrap');
    if(fw)fw.style.display='none';
    if(tw)tw.style.display='block';
    return false;
  };
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
